import React from 'react';

import style from './style.module.scss';

interface IProps {
  label: string;
  value: string | number;
  rightElement?: React.ReactElement;
}

const InfoField: React.FC<IProps> = ({ label, value, rightElement = null }) => {
  return (
    <div className={style.infoFieldBlock}>
      <div className={style.infoFieldLabel}>{label}</div>
      <div className={style.infoField}>
        <div className={style.infoFieldValue}>{value}</div>
        {rightElement}
      </div>
    </div>
  );
};

export default InfoField;
